<template>
  <div class="box7-page">
    <div class="inseec-title">知名校友</div>
    <div class="card-box">
      <!-- 校友图片列表 -->
      <div class="alumni-images">
        <div
          v-for="(alumnus, index) in alumniList"
          :key="index"
          class="alumni-image-item"
          :class="{ active: currentIndex === index }"
          @click="selectAlumni(index)"
        >
          <img :src="alumnus.image" :alt="alumnus.name" />
        </div>
      </div>

      <!-- 校友信息展示 -->
      <div class="alumni-info">
        <h3 class="alumni-name">{{ alumniList[currentIndex].name }}</h3>
        <p class="alumni-title">{{ alumniList[currentIndex].title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AlumniSection",
    data() {
      return {
        // 当前选中的校友索引，默认选中第一个
        currentIndex: 0,
        // 校友数据列表
        alumniList: [
          {
            image: require("../../../assets/coursePage/inseec/box7/student1.png"),
            name: "Didier Gambar",
            title: "丰田欧洲公司销售、市场和客户体验副总裁",
          },
          {
            image: require("../../../assets/coursePage/inseec/box7/student2.png"),
            name: "Guillaume Du Poy",
            title: "EPOKA UP总经理",
          },
          {
            image: require("../../../assets/coursePage/inseec/box7/student3.png"),
            name: "Sofiane Laurent",
            title: "GOMYPARTNER的首席执行官和联合创始人",
          },
          {
            image: require("../../../assets/coursePage/inseec/box7/student4.png"),
            name: "Lucas",
            title: "谷歌机构品牌经理",
          },
        ],
      };
    },
    methods: {
      // 选择校友，更新当前索引
      selectAlumni(index) {
        this.currentIndex = index;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .box7-page {
    background: #ffffff;
    padding: 80px 40px;
    .inseec-title {
      font-weight: 600;
      font-size: 44px;
      color: #012d72;
      line-height: 64px;
      text-align: center;
    }
    .card-box {
      margin-top: 48px;

      // 校友图片列表样式
      .alumni-images {
        display: flex;
        justify-content: center;
        gap: 20px;
        margin-bottom: 32px;

        .alumni-image-item {
          cursor: pointer;
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.3s ease;
          border: 4px solid transparent;

          // 选中状态样式
          &.active {
            border-color: #012d72;
            box-shadow: 0 4px 12px rgba(1, 45, 114, 0.2);
          }

          img {
            width: 100%;
            height: auto;
            display: block;
          }
        }
      }

      // 校友信息样式
      .alumni-info {
        text-align: center;

        .alumni-name {
          font-weight: 500;
          font-size: 40px;
          color: #122a4f;
          line-height: 56px;
          margin-bottom: 8px;
        }

        .alumni-title {
          font-weight: 400;
          font-size: 26px;
          color: #122a4f;
          line-height: 40px;
        }
      }
    }
  }
</style>
